'use client';

import { useRatingReviews } from '@/hooks/useRatingReviews';
import { GoogleReviewServer } from './server';

export default function GoogleReviewsClient() {
  const result = useRatingReviews();
  const placeId = process.env.NEXT_PUBLIC_GOOGLE_PLACE_ID ?? '';

  if (result.loading) {
    return <GoogleReviewServer href="#" rating={0} />;
  }

  if (!result.rating) {
    return null;
  }

  return (
    <GoogleReviewServer
      href={`https://search.google.com/local/reviews?placeid=${placeId}`}
      rating={result.rating}
    />
  );
}
